import { createGlobalStyle } from 'styled-components';
import { BASE_FONT_SIZE, STATIC_BASE_URL, weightToNumber } from '@anwb/style-utilities';
import { collectFontCombinations } from './utils/collectFontCombinations';
import { fontToSource } from './utils/fontToSource';
/**
 * This component creates a Styled Components global style
 * which defines the font-faces that can be used. It looks
 * at the current theme, and collects the font combinations
 * that are defined in that theme.
 */
export const Fonts = createGlobalStyle `
${({ cdnBaseUrl, theme }) => collectFontCombinations(theme)
    .map((font) => `@font-face {
  font-family: '${font.family}';
  src: ${fontToSource(font, cdnBaseUrl !== null && cdnBaseUrl !== void 0 ? cdnBaseUrl : `${STATIC_BASE_URL}/poncho/fonts/`)};
  font-weight: ${weightToNumber(font.weight, font.family)};
  ${font.style ? `font-style: ${font.style.toLowerCase()}` : ''};
}`)
    .join('')}

body {
  font-family: Verdana, Arial, sans-serif, ui-icons, illustrative-icons;
  font-size: ${BASE_FONT_SIZE}px;
}

/**
 * Remove when Core UI Stylesheet is removed.
 */
.PONCHO-icon {
	font-weight: normal;
}
`;
//# sourceMappingURL=Fonts.js.map